import { __decorate } from "tslib";
import { classNameWithModifier } from '@slickdeals/durango/dist/javascript/utilities/css';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import Heap from '../heap/heap';
// eslint-disable-next-line import/extensions
import { ClassNames } from '../patterns/cashbackSearchResultsBanner';
// eslint-disable-next-line import/extensions
import { name as cashbackSearchBannerServiceName } from './cashbackSearchResultsBannerService';
import '../../scss/patterns/cashbackSearchResultsBanner.scss';
/** The name of the module */
export const name = 'CashbackSearchResultsBannerInjector';
/** Dependencies for injection */
export const dependencies = Object.assign({}, Injector.createDependency(cashbackSearchBannerServiceName, InjectorScope.Factory));
let InjectCashbackSearchResultsBanner = class InjectCashbackSearchResultsBanner {
    constructor(cashbackBannerService) {
        this.cashbackBannerService = cashbackBannerService;
    }
    /**
     * initializes a cashback banner to append to the page, if a banner doesn't already exist, replace the existing extension search banner
     *
     * @param props object built from offer data from backend
     */
    injectBanner(bannerProps) {
        const cashbackSearchResultsBanner = document.createElement('div');
        cashbackSearchResultsBanner.classList.add('blueprint');
        cashbackSearchResultsBanner.appendChild(this.cashbackBannerService.initializeBanner(bannerProps));
        const extensionSearchBanner = document.getElementById('extensionSearchBanner');
        const banner = document.querySelector('[data-promo-type="cashbackSearchResultsBanner"]');
        if (!banner) {
            if (extensionSearchBanner) {
                extensionSearchBanner.replaceWith(cashbackSearchResultsBanner);
            }
            else {
                document.getElementById('searchResults').prepend(cashbackSearchResultsBanner);
            }
            setTimeout(() => {
                cashbackSearchResultsBanner.querySelector(`.${ClassNames.Default}`).classList.add(classNameWithModifier(ClassNames.Default, 'active'));
            }, 250);
            const heap = new Heap();
            if (bannerProps.testVariant) {
                heap.track(`${bannerProps.trackingKey} - Impression`, { testVariant: bannerProps.testVariant }).catch(() => { });
            }
            else {
                heap.track(`${bannerProps.trackingKey} - Impression`).catch(() => { });
            }
        }
    }
};
InjectCashbackSearchResultsBanner = __decorate([
    injectable(name, dependencies)
], InjectCashbackSearchResultsBanner);
export default InjectCashbackSearchResultsBanner;
